














import { Vue, Component, Watch } from 'vue-property-decorator';
import { SHOW_LOADER, SHOW_SNACKBAR } from '../../common/constants';
import { eventBus } from '../../main';
import errorModule from '../../store/modules/error.module';

@Component
export default class App extends Vue {
  snackbarText = '';

  snackbar = false;

  loadingRequest = false;

  @Watch('errorMessage')
  changeError(message: string): void {
    // Check to see if message is set, if so, show the snack message.
    if (message !== '') {
      this.snackbarText = message;
      this.snackbar = true;
    }
  }

  @Watch('loadingStatus')
  changeLoading(status: boolean): void {
    this.loadingRequest = status;
  }

  // Initialize eventBus to handle the snackbar and loaders
  created(): void {
    eventBus.$on(SHOW_SNACKBAR, this.showSnackbar);
    eventBus.$on(SHOW_LOADER, this.showLoader);
  }

  showLoader(payload: boolean): void {
    this.loadingRequest = payload;
  }

  showSnackbar(payload: string): void {
    this.snackbar = true;
    this.snackbarText = payload;
  }

  get errorMessage(): string {
    return errorModule.message;
  }

  get loadingStatus(): boolean {
    return errorModule.isLoading;
  }
}
